import { ConnectionUseCase } from "@/usecases/connection"
import { Flex, Spinner, Text } from "@chakra-ui/react"
import React, { useEffect, useMemo, useState } from "react"

export const ConnStateNotifier: React.FC = () => {
  // 状态提示文本
  const [notifiedText, setNotifiedText] = useState<string | null>(null)
  // 是否展示提示
  const shouldShow = useMemo(() => notifiedText !== null, [notifiedText])
  useEffect(() => {
    ConnectionUseCase.addConnCallback({
      onConnected: () => {
        // 连接成功，影藏状态提示
        setNotifiedText(null)
      },
      onReconnect: () => {
        // 重连中
        setNotifiedText("重连中...")
      },
    })
  }, [])

  if (!shouldShow) return <></>

  return (
    <Flex
      position="fixed"
      top="32px"
      right="16px"
      width="320px"
      minHeight="48px"
      padding="12px"
      alignItems="center"
      gap="12px"
      background="#2C2C44"
      zIndex={999}
      borderRadius="8px"
      boxShadow="0 4px 8px rgba(29, 29, 36, 0.2)"
    >
      <Spinner
        thickness="2px"
        speed="0.95s"
        emptyColor="transparent"
        color="white"
        boxSize="24px"
      />
      <Text color="white" fontSize="17px">
        {notifiedText}
      </Text>
    </Flex>
  )
}
